import EmptyState from '../ui/EmptyState';

export default function ActivityTab({ candidate }) {
  if (candidate.recent_activity.length === 0) {
    return <EmptyState title="No activity recorded yet." />;
  }

  return (
    <ul className="space-y-3">
      {candidate.recent_activity.map((entry) => (
        <li key={entry.id} className="border-b border-gray-100 pb-3 last:border-0">
          <p className="text-sm text-gray-800">{entry.description}</p>
          <p className="text-xs text-gray-400">{new Date(entry.created_at).toLocaleString()}</p>
        </li>
      ))}
    </ul>
  );
}
